'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var HousecallAppIcon = function HousecallAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 21.1 21.1"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("g", {
    id: "Layer_1-2"
  }, React__default["default"].createElement("g", null, React__default["default"].createElement("polygon", {
    points: "4.4,3.9 4.4,17.5 11,21.1 11,19.1 11,17 11,4.5 11,2.4 11,0"
  }), React__default["default"].createElement("polygon", {
    points: "15.7,19.1 12.9,19.1 12.9,17.5 14.2,17.5 14.2,3.9 12.9,3.9 12.9,2.3 15.8,2.3"
  })))));
};

var HousecallAppIcon$1 = iconStyles()(HousecallAppIcon);

module.exports = HousecallAppIcon$1;
